/// <reference path="../lib/jquery.d.ts" />

import {VideoBoxControl as videoBoxControl} from "./videoBoxControl";
import {ReadingTimeControl as readingTime} from "./readingTime";
import {SharePageControl as sharePageControl} from "./sharePage";
import {SiteNavControl as siteNavControl} from './siteNavControl'
import {ResourcesControl as resourcesControl} from './resourcesControl'
import {LinkListControl as linkListControl} from './linkListControl'
import {AccordionControl as accordionControl} from './accordionControl';
import {FilterControl as filterControl} from './filterControl';
import {PopupControl as popupControl} from './popupControl';
import {TabControl as tabControl} from './tabControl'
import {GoogleMapControl as googleMapControl} from "./googleMapControl";
import {MembershipCenterPopupControl as membershipControl} from "./MembershipCenterPopupControl";
import {ProductPricingFindACentreControl as productPricingFindACentreControl} from "./ProductPricingFindACentreControl";
import {SpinnerControl as spinnerControl} from './spinnerControl';
import {CmsContentControl as cmsContentControl} from './cmsContentControl'

import {TrialSignupSession as trialSignupSession} from "./trialSignupSession";
import {TrialSlotSelection as trialSlotSelection } from "./trialSlotSelection";
import {TrialReturningCustomer as trialReturningCustomer } from "./trialReturningCustomer";
import {MemberSignupSession as memberSignupSession } from "./memberSignupSession";
import {MemberSignupReturningCustomer as memberSignupReturningCustomer } from "./memberSignupReturningCustomer";
import {MemberSignupSlotSelection as memberSignupSlotSelection } from "./memberSignupSlotSelection";

import {shim} from './helpers/shim';
import {findCenterControl} from "./findCenterControl";
import {findSchoolControl} from "./findSchoolControl";
import {lottieAnimationControl} from "./lottieAnimation";
import {CarouselControl} from "./carouselControl";
import {MarqueeControl} from "./marqueeControl";
import {PasswordDisplayControl} from "./passwordDisplayControl";
import {ReadMoreControl} from "./readMoreControl";


class InitSiteJs {
    private body: HTMLElement = document.body;

    public videoControls: Array<videoBoxControl> = [];
    public readingTimeControls: Array<readingTime> = [];
    public sharePageControls: Array<sharePageControl> = [];
    public filterControls: Array<filterControl> = [];
    public accordionControls: Array<accordionControl> = [];
    public popupControls: Array<popupControl> = [];
    public spinnerControls: Array<spinnerControl> = [];
    public findCenterControls: Array<findCenterControl> = [];
    public findSchoolControls: Array<findSchoolControl> = [];
    public tabControls: Array<tabControl> = [];
    public googleMapControls: Array<googleMapControl> = [];
    public membershipControls: Array<membershipControl> = [];
    public productPricingFindACentreControls: Array<productPricingFindACentreControl> = [];
    public lottieAnimationControls: Array<lottieAnimationControl> = [];
    public carouselControls: Array<CarouselControl> = [];
    public marqueeControls: Array<MarqueeControl> = [];
    public passwordDisplayControl: Array<PasswordDisplayControl> = [];
    public readMoreControl: Array<ReadMoreControl> = [];

    public trialSignupSession: Array<trialSignupSession> = []
    public trialSlotSelection: Array<trialSlotSelection> = []
    public trialReturningCustomer: Array<trialReturningCustomer> = []
    public memberSignupSession: Array<memberSignupSession> = []
    public memberSignupReturningCustomer: Array<memberSignupReturningCustomer> = []
    public memberSignupSlotSelection: Array<memberSignupSlotSelection> = []


    constructor() {

        $('[data-animation]').each((index: number, element: Element) => {
            this.lottieAnimationControls.push(new lottieAnimationControl(element as HTMLElement));
        })

        $('[data-carousel]').each((index: number, element: Element) => {
            this.carouselControls.push(new CarouselControl(element as HTMLElement));
        })
        
        $('[data-youtubeId]').each((index: number, element: Element) => {
            this.videoControls.push(new videoBoxControl(element as HTMLElement));
        })

        $('[data-accordionToggle]').each((index: number, element: Element) => {
            this.accordionControls.push(new accordionControl(element as HTMLElement));
        })

        $('[data-marquee]').each((index: number, element: Element) => {
            this.marqueeControls.push(new MarqueeControl(element as HTMLElement));
        })

        $('[data-password-display]').each((index: number, element: Element) => {
            this.passwordDisplayControl.push(new PasswordDisplayControl(element as HTMLElement));
        })

        $('[data-read-more]').each((index: number, element: Element) => {
            this.readMoreControl.push(new ReadMoreControl(element as HTMLElement));
        })

        $('[data-readingTime]').each((index: number, element: Element) => {
            this.readingTimeControls.push(new readingTime(element as HTMLElement));
        })

        $('[data-sharepage]').each((index: number, element: Element) => {
            this.sharePageControls.push(new sharePageControl(element as HTMLElement));
        })
        $('[data-filtercontrol]').each((index: number, element: Element) => {
            this.filterControls.push(new filterControl(element as HTMLElement));
        })
        
        $('[data-popup]').each((index: number, element: Element) => {
            this.popupControls.push(new popupControl(element as HTMLElement));
        })

        $('[data-use-spinner]').each((index: number, element: Element) => {
            this.spinnerControls.push(new spinnerControl(element as HTMLFormElement));
        })

        $('[data-tabs]').each((index: number, element: Element) => {
            this.tabControls.push(new tabControl(element as HTMLElement));
        })

        $('[data-findCenter]').each((index: number, element: Element) => {
            this.findCenterControls.push(new findCenterControl(element as HTMLElement));
        })

        $('[data-findSchool]').each((index: number, element: Element) => {
            this.findSchoolControls.push(new findSchoolControl(element as HTMLElement));
        })

        $('[data-googlemap]').each((index: number, element: Element) => {
            this.googleMapControls.push(new googleMapControl(element as HTMLElement));
        })

        $('[data-membership-center-popup]').each((index: number, element: Element) => {
            this.membershipControls.push(new membershipControl(element as HTMLElement));
        })

        $('[data-product-pricing-find-a-centre]').each((index: number, element: Element) => {
            this.productPricingFindACentreControls.push(new productPricingFindACentreControl(element as HTMLElement));
        })

        $('[data-trial-signup-session]').each((index: number, element: Element) => {
            this.trialSignupSession.push(new trialSignupSession(element as HTMLElement));
        })

        $('[data-trial-session-picker]').each((index: number, element: Element) => {
            this.trialSlotSelection.push(new trialSlotSelection(element as HTMLElement));
        })

        $('[data-trial-return-customer]').each((index: number, element: Element) => {
            this.trialReturningCustomer.push(new trialReturningCustomer(element as HTMLElement));
        })

        $('[data-member-signup-session]').each((index: number, element: Element) => {
            this.memberSignupSession.push(new memberSignupSession(element as HTMLElement));
        })

        $('[data-member-signup-return-customer]').each((index: number, element: Element) => {
            this.memberSignupReturningCustomer.push(new memberSignupReturningCustomer(element as HTMLElement));
        })
        $('[data-member-signup-session-picker]').each((index: number, element: Element) => {
            this.memberSignupSlotSelection.push(new memberSignupSlotSelection(element as HTMLElement));
        })

        let siteNavControlInstance = new siteNavControl();
        let resourcesControlInstance = new resourcesControl();
        let linkListControlInstance = new linkListControl();
        let cmsContentControlInstance = new cmsContentControl();
    }
}


document.addEventListener("DOMContentLoaded", function (event) {
    var siteJs = new InitSiteJs();
});